import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const localAuth = localStorage?.getItem("auth");

  return localAuth ? children : <Navigate to="/bau" />;
}
